import { Icon } from "../../lib/icon";
import { StaggerItem } from "../common/Reveal";

export default function TalentCard({ service }) {
  return (
    <StaggerItem>
      <div
        className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink-800/50 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-sky-400/40"
        data-testid={`talent-card-${service.name.toLowerCase().replace(/\s+/g, "-")}`}
      >
        <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-400 transition-colors duration-500 group-hover:text-sky-300">
          <Icon name={service.icon} className="h-6 w-6" />
        </div>
        <h3 className="font-heading text-xl font-bold tracking-tight text-white">
          {service.name}
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">{service.description}</p>
      </div>
    </StaggerItem>
  );
}
